/**
 * Custom Label Mappings for Shared Enum Values
 *
 * These provide human-readable labels for enum values that don't format well
 * with the default camelCase-to-Title-Case conversion.
 *
 * Usage:
 * Import these in LOC definition files and pass to builder functions or
 * use with createEnumFormatter/createValueFormatter.
 *
 * @example
 * import { benefitDurationLabels } from "../shared/definitions/customLabels";
 *
 * ...buildTypeAmountBenefitPair({
 *   prefix: "benefitDuration",
 *   typeLabel: "Benefit Duration",
 *   typeCustomLabels: benefitDurationLabels,
 *   // ... rest of config
 * })
 */

/**
 * Custom labels for BenefitDurationTypeEnum
 *
 * Used by: LTD, Individual Disability
 */
export const benefitDurationLabels = {
  ssnra: "SSNRA",
  ssnraWithRbd: "SSNRA with RBD",
  rbdWithSsnra: "RBD with SSNRA",
  adea1WithSsnra: "ADEA 1 with SSNRA",
  adea1: "ADEA 1",
  adea2: "ADEA 2",
  adea3: "ADEA 3",
  adea4: "ADEA 4",
  twoYearAdea: "2 YEAR ADEA",
  threeYearAdea: "3 YEAR ADEA",
  fiveYearAdea: "5 YEAR ADEA",
  tenYearAdeaSchedule: "10 YEAR ADEA SCHEDULE",
  ssAdea: "SS ADEA",
  toAge65: "To age 65",
  toAge67: "To age 67",
  laterOfAgeOrSsnra: "Later of age or SSNRA",
  lesserOfRbdOrNumberOfYears: "Lesser of RBD or number of years",
};

/**
 * Custom labels for DefinitionOfDisabilityEnum
 *
 * Used by: LTD, STD, Individual Disability
 */
export const definitionOfDisabilityLabels = {
  lossOfEarningsAndDuties: "Loss of Duties AND Loss of Earnings",
  lossOfEarningsOrLossOfDuties: "Loss of Duties OR Loss of Earnings",
};

/**
 * Custom labels for EmployerContributionEnum
 *
 * Used by: LTD, STD, Individual Disability, Dental PPO, Dental HMO, Vision, EAP, Basic Life
 */
export const employerContributionLabels = {
  oneHundredPercentEmployerPaid: "100% Employer Paid",
};

/**
 * Custom labels for DefinitionOfEarningsEnum
 *
 * Used by: LTD, STD
 */
export const definitionOfEarningsLabels = {
  salary: "Base Salary",
  salaryPlusCommissions: "Salary + Comm",
  salaryPlusBonus: "Salary + Bonus",
  salaryPlusBonusPlusCommissions: "Salary + Bonus + Comm",
  priorYearW2: "Prior Year W2",
  k1: "K1",
};

/** Custom labels for DeductibleWaivedPreventativeEnum
 *
 * Used by: Dental PPO
 */
export const deductibleWaivedPreventativeLabels = {
  included: "Yes",
  notIncluded: "No",
};
